/**
 * Vertical shift (px) for mobile battle HUD: lifts player bottom dock (general, health, O/S/C, hand)
 * away from resign / end-turn, and shifts opponent top dock (avatars, intel, O/S/C, drones) by the
 * same amount from the top edge. Keep in sync across mobile battle components.
 */
export const MOBILE_BATTLE_DOCK_LIFT_PX = 12;

/** Opponent avatar cluster: higher than old `5 + MOBILE_BATTLE_DOCK_LIFT_PX`, aligned with tighter top dock. */
export const MOBILE_OPPONENT_AVATARS_TOP_PX = 6;
